module.exports = __webpack_public_path__ + "static/media/upload-image-button.f8d17aa2.svg";